import ReactTooltip from "react-tooltip";
import "./CustomTooltipColumn.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useMemo } from "react";
import { v4 as uuid } from 'uuid';

function CustomTooltipColumn(props) {

  const id = uuid();

  const tooltip = useMemo(() => {
    const { isEditable } = props;

    const title = props?.tooltip?.title;
    const description = props?.tooltip?.description;

    if (isEditable) {
      return {
        title: title || "Campo editável",
        description: description || "Clique na célula para editar."
      }
    }

    return {
      title: title,
      description: description,
    }
  }, [props.tooltip, props.isEditable]);

  return (
    <div className="custom-tooltip-column-content">
      <span className="custom-tooltip-column-name">{props.name}</span>
      <IoMdInformationCircleOutline
        data-tip data-for={`info-tooltip_${id}`}
        size={16}
        color="#007bff"
        style={{ cursor: 'pointer' }}
      />
      <ReactTooltip id={`info-tooltip_${id}`} place="right" effect="solid" >
        {props.tooltip && props.tooltip.title && (
          <div>
            <strong>{props.tooltip.title}</strong> <br />
          </div>
        )}
        {tooltip.description}
      </ReactTooltip>

    </div>
  )
}

export default CustomTooltipColumn;